var angular = require('angular');
var _module = require('../module');

_module.component('lrfooter', {
    bindings: {
        footerClass: '<'
    },
    controllerAs: 'lrfooter',
    controller: [
        '$log',
        '$scope',

        function lrfooterCtrl($log, $scope) {
            $log.debug('lrfooter');

            $scope.APP_VERSION_NUMBER = '__GIT_MY_VERSION__';
            $scope.copyrightYear = new Date().getFullYear();
        }
    ],
    template: require('./index.html')
});
